export const ACCOUNT_TYPES = [
  'Checking',
  'Savings'
]
